const startUpper = (s: string) => {
	return s.substring(0, 1).toUpperCase() + s.substring(1, s.length);
};
export default startUpper;
